import { useContext } from "react";
import { NotificationContext, type NotificationContextValue } from "~/contexts/notificationContext";

/**
 * Hook to access notifications from context
 *
 * Must be used within a NotificationProvider.
 *
 * Example:
 * ```tsx
 * const { notifications, addRollNotification, dismissNotification } = useNotifications();
 * ```
 *
 * @returns Notification context value
 * @throws Error if used outside of NotificationProvider
 */
export const useNotifications = (): NotificationContextValue => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error("useNotifications must be used within a NotificationProvider");
  }
  return context;
};
